import { useCallback } from 'react';

import last from 'lodash/last';

import { useBreadCrumbItems } from './breadCrumbs';
import { useCreateFavoritePage } from './queries/favoritePages';

const useAddCurrentFavoritePage = (config) => {
    const items = useBreadCrumbItems();
    const [createFavoritePage, info] = useCreateFavoritePage(config);

    const handleAddFavorite = useCallback(() => {
        const pageTitle = items.map((item) => item.title).join(' — ');
        const pathname = last(items).url;

        createFavoritePage({ title: pageTitle, path: pathname });
    }, [items, createFavoritePage]);

    return [handleAddFavorite, info];
};

export {
    useAddCurrentFavoritePage,
};
